import { isExpired } from "react-jwt";
import Cookies from 'js-cookie';
import {jwtDecode} from "jwt-decode";
import axios from "axios";
import configData from "../config/config.json";

export const TokenVerificationLoggedin = () => {
    let status= Cookies.get("token_xapads_ssp")?true:false;
    if(!status){
        window.location.replace("/login")
    }

    if(status){
    let token= Cookies.get("token_xapads_ssp")
    const isMyTokenExpired = isExpired(token);
    if(isMyTokenExpired){
        Cookies.remove("token_xapads_ssp")
        window.location.replace("/login")
      }
    }
  }

  export const TokenVerificationLoggedOut = (statusData = null) => {
      let status= Cookies.get("token_xapads_ssp")?true:false;
       if (status) {
        let token= Cookies.get("token_xapads_ssp")
        let id = jwtDecode(token)._id;
        let role =jwtDecode(token).role

          if (role === "sa" ||role === "mobops" ||role === "am") {
            window.location.replace("/dashboard");
          }

          if((role==='admin' || role==='u_admin')){
            const applyRedirect = (pubStatus, approveUser) => {
              if(pubStatus==="onboard" || pubStatus==="new" || pubStatus==="rejected" ||(pubStatus==="declined" && !approveUser)){
                window.location.replace("/onboarding")
              } else {
                window.location.replace("/dashboard")
              }
            };

            if (statusData) {
              applyRedirect(statusData.pubStatus, statusData.approveUser);
            } else {
              axios
              .get(configData.SERVER_URL + "user/status?_id="+id)
              .then((response) => {
                applyRedirect(response.data.data.status, response.data.data.approveUser);
              })
            }
          }
      }
  }


  export const ScreenView = (statusData = null) => {
    let status= Cookies.get("token_xapads_ssp")?true:false;
    if (status) {
    let token= Cookies.get("token_xapads_ssp")
    let id = jwtDecode(token)._id;
    let role =jwtDecode(token).role

    if((role==='admin' || role==='u_admin')){
      const applyRedirect = (pubStatus, approveUser) => {
        if(pubStatus==="onboard" || pubStatus==="new" || pubStatus==="rejected" || (pubStatus==="declined" && !approveUser)){
          window.location.replace("/onboarding")
        }
      };

      if (statusData) {
        applyRedirect(statusData.pubStatus, statusData.approveUser);
      } else {
        axios
        .get(configData.SERVER_URL + "user/status?_id="+id)
        .then((response) => {
          applyRedirect(response.data.data.status, response.data.data.approveUser);
        })
        .catch((error) => {});
      }
    }
    }
  }

  export const ScreenViewOnboarding = (statusData = null) => {
    let status= Cookies.get("token_xapads_ssp")?true:false;
    if (status) {
    let token= Cookies.get("token_xapads_ssp")
    let id = jwtDecode(token)._id;
    let role =jwtDecode(token).role

    if((role==='admin' || role==='u_admin')){
      const applyRedirect = (pubStatus) => {
        if(pubStatus==="approved" || pubStatus==="archived"){
          window.location.replace("/dashboard")
        }
      };

      if (statusData) {
        applyRedirect(statusData.pubStatus);
      } else {
        axios
        .get(configData.SERVER_URL + "user/status?_id="+id)
        .then((response) => {
          applyRedirect(response.data.data.status);
        })
        .catch((error) => {});
      }
    }
    }

  }

  export const BlockAdmin = (statusData = null) => {
    let status= Cookies.get("token_xapads_ssp")?true:false;
    if (status) {
    let token= Cookies.get("token_xapads_ssp")
    let id = jwtDecode(token)._id;
    let role =jwtDecode(token).role

    if((role==='admin' || role==='u_admin')){
      const applyRedirect = (pubStatus, approveUser) => {
        if(pubStatus==="onboard" || pubStatus==="new" || pubStatus==="rejected" || (pubStatus==="declined" && !approveUser)){
          window.location.replace("/onboarding")
        } else {
          window.location.replace("/dashboard")
        }
      };

      if (statusData) {
        applyRedirect(statusData.pubStatus, statusData.approveUser);
      } else {
        axios
        .get(configData.SERVER_URL + "user/status?_id="+id)
        .then((response) => {
          applyRedirect(response.data.data.status, response.data.data.approveUser);
        })
        .catch((error) => {});
      }
    }
    }

  }

  export const BlockOtherThanAdmin = () => {
    let status= Cookies.get("token_xapads_ssp")?true:false;
    if (status) {
    let token= Cookies.get("token_xapads_ssp")
    // let id = jwtDecode(token)._id;
    let role =jwtDecode(token).role

    if((role!=='admin' && role!=='u_admin')){
      window.location.replace("/dashboard")
     }
 
    }
  
  }

  export const BlockOtherThanSA = () => {
    let status= Cookies.get("token_xapads_ssp")?true:false;
    if (status) {
    let token= Cookies.get("token_xapads_ssp")
    // let id = jwtDecode(token)._id;
    let role =jwtDecode(token).role

    if(role!=='sa'){
      window.location.replace("/dashboard")
     }
 
    }
  
  }

    export const BlockAM = () => {
    let status= Cookies.get("token_xapads_ssp")?true:false;
    if (status) {
    let token= Cookies.get("token_xapads_ssp")
    // let id = jwtDecode(token)._id;
    let role =jwtDecode(token).role

    if(role==='am'){
      window.location.replace("/dashboard")
     }
 
    }
  
  }

     export const Block_U_Admin = () => {
    let status= Cookies.get("token_xapads_ssp")?true:false;
    if (status) {
    let token= Cookies.get("token_xapads_ssp")
    // let id = jwtDecode(token)._id;
    let role =jwtDecode(token).role

    if(role==='u_admin'){
      window.location.replace("/dashboard")
     }
 
    }
  
  }


  


  




